import { allPhotos } from "./allPhotos";

export const makingOfPhotos = allPhotos.filter(function(obj) { return obj.type.startsWith('Making of'); });